import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Encounter } from '@mona/models';
import { ChangeLogService } from '@mona/pdms/data-access-changelog';
import { selectSelectedEncounter } from '@mona/pdms/data-access-encounters';
import { AuditEvent } from '../../../../shared/src/lib/types/r4b.type';
import * as AuditLogActions from '../state/actions/audit.log.actions';
import { AuditLogState } from '../state/reducers/audit-log.reducer';
import {
    selectAuditLogDisplayedItems,
    selectAuditLogError,
    selectAuditLogLoading,
    selectBackendPageSize,
    selectPageSize,
    selectTotalCount,
} from '../state/selectors/audit-log-selector';

/**
 * Audit log service
 */
@Injectable({ providedIn: 'root' })
export class AuditLogService {
    // Audit log loading
    loading$: Observable<boolean> = this.store.select(selectAuditLogLoading);

    // Audit log error
    error$: Observable<string> = this.store.select(selectAuditLogError);

    // Audit log page size
    pageSize$: Observable<number> = this.store.select(selectPageSize);

    // Audit log display items
    displayedItems$: Observable<AuditEvent[]> = this.store.select(selectAuditLogDisplayedItems);

    // Audit log total count
    totalCount$: Observable<number> = this.store.select(selectTotalCount);

    // Audit log backend page size
    backendPageSize$: Observable<number> = this.store.select(selectBackendPageSize);

    // Selected encounter
    currentEncounter$: Observable<Encounter> = this.store.select(selectSelectedEncounter);

    /**
     * Constructor
     *
     * @param store Store
     * @param changeLogService ChangeLogService
     */
    constructor(private store: Store<AuditLogState>, private changeLogService: ChangeLogService) {}

    /** Clear audit log */
    clearAuditLog(): void {
        this.store.dispatch(AuditLogActions.clearAuditLog());
    }

    /**
     * Load audit log
     * @param encounter
     * @param backendPage
     */
    loadAuditLog(encounter: Encounter, backendPage: number): void {
        this.store.dispatch(AuditLogActions.loadAuditLogs({ encounter, backendPage }));
    }

    /**
     * Set audit log page
     * @param currentPage
     * @param pageSize
     */
    setPage(currentPage: number, pageSize: number): void {
        this.store.dispatch(AuditLogActions.setPage({ currentPage, pageSize }));
    }
}
